import { useState, useEffect, useCallback } from 'react';

const RECENTS_KEY = 'ltbb_recent_loops';
const MAX_RECENTS = 12;

export const useRecents = () => {
  const [recentLoops, setRecentLoops] = useState([]);
  
  // Load recents from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(RECENTS_KEY);
      if (stored) {
        setRecentLoops(JSON.parse(stored));
      }
    } catch (e) {
      console.error('Error loading recents:', e);
    }
  }, []);
  
  // Add a loop to recents
  const addToRecents = useCallback((loop) => {
    setRecentLoops(prev => {
      // Remove if already exists
      const filtered = prev.filter(l => l.loop_id !== loop.loop_id);
      // Add to front
      const updated = [loop, ...filtered].slice(0, MAX_RECENTS);
      // Save to localStorage
      try {
        localStorage.setItem(RECENTS_KEY, JSON.stringify(updated));
      } catch (e) {
        console.error('Error saving recents:', e);
      }
      return updated;
    });
  }, []);
  
  // Clear recents
  const clearRecents = useCallback(() => {
    setRecentLoops([]);
    localStorage.removeItem(RECENTS_KEY);
  }, []);
  
  return { recentLoops, addToRecents, clearRecents };
};
